import React, { useState, useEffect, useCallback } from "react";
import { Container } from "@mui/material";
// import InvoiceDatagrid from "./invoiceDatagrid"; // This line was commented out in the user-provided original code
import InvoicesListDatagrid from "./invoicesListDatagrid";
import Copyright from "../Copyright";
import httpRequest from "../HttpService";
import { palette } from "../palette";
import Button from "@mui/material/Button";
import PaymentIcon from "@mui/icons-material/Payment";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CustomDialog from "../newOrder/components/dialog/Dialog"; // Verify this path is correct
import { Snackbar, Alert } from "@mui/material";
import { useUserContext} from "../lib/user_context"; // Verify this path is correct
import { useSearchParams, useNavigate } from "react-router-dom";

/*
  Developer Note: Example ConvergePay callback URL parameters for reference.
  These parameters are expected when the payment gateway redirects back to this page.
  - ssl_company, ssl_phone, etc.: Various billing/shipping details.
  - ssl_amount: The transaction amount.
  - ssl_description: Typically the Account Number for the transaction.
  - ssl_invoice_number: Can be a single invoice or a comma-separated list.
  - ssl_txn_id: The unique Transaction ID from the payment gateway.
  - ssl_result: '0' for success, other values for failure/cancellation.
  - ssl_result_message: Descriptive message from the gateway.
*/
export default function Invoice(props)  {
    const { sessionAccount } = useUserContext();
    const navigate = useNavigate();
    // const IsEmbbed = localStorage.getItem('IsEmbedded')!==null && localStorage.getItem('IsEmbedded')==='yes'; // Code from user upload
    // const account = localStorage.getItem('current_accountNumber')!== '' ? localStorage.getItem('current_accountNumber'):localStorage.getItem('accountNumber'); // Code from user upload
    const account = sessionAccount; // Using sessionAccount from context, as per user upload logic
    // const showPaymentPart = localStorage.getItem("accountNumber") === "9910" && IsEmbbed !== "yes"; // Code from user upload
    const showPaymentPart = false; // Value from user upload code snapshot

    const [invoiceParams] = useSearchParams();

    const [selectedInvoices,setSelectedInvoices] = useState({ invoiceList: [], paymentAmount: 0,});
    const [totalOutstanding,setTotalOutstanding] = useState({ invoiceList: [], paymentAmount: 0,});
    const [openDialog, setOpenDialog] = useState(false); // State from user upload code, reinstated
    const [openCustomDialog, setOpenCustomDialog] = useState(false);
    const [customDialogTitle, setCustomDialogTitle] = useState('');
    const [customDialogMsg, setCustomDialogMsg] = useState('');
    const [openSnack, setOpenSnack] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');
    const [paymentData, setPaymentData] = useState({});
    const [loading, setLoading] = useState(false);

    // This useEffect block is for Tidio Chat integration.
    /*
    useEffect(() => {
      const loadScript = (callback) => {
          const tidioScript = document.createElement("script");
          tidioScript.src = "//code.tidio.co/zj4irmzxslnsmyu84t0zthq5r1m9jgxl.js";
          tidioScript.id = "tidioscript";
          window.document.body.appendChild(tidioScript);
          //document.getElementById("tidio-chat-iframe").style.visibility = 'visible'; // Comment from user upload
          callback();
      };

      loadScript(() => {
          const tidioChatIframe = document.getElementById("tidio-chat-iframe");
          if (tidioChatIframe) {
             tidioChatIframe.style.display = 'inline';
             console.log('Tidio chat iframe is now visible'); // Log from user upload
          } else {
              console.log('Tidio chat iframe not found at the time of script load.'); // Log from user upload
          }
      });

      return () => {
          const removeScript = (callback) => {
              console.log("Script removing"); // Log from user upload
              const scriptElement = document.getElementById("tidio-chat"); // ID from user upload
              if (scriptElement && scriptElement.parentNode) {
                  //scriptElement.parentNode.removeChild(scriptElement); // This line was commented out in user upload
                  if (document.getElementById("tidio-chat-iframe")) {
                    document.getElementById("tidio-chat-iframe").style.display='none';
                  }
                  console.log('Script removed',document); // Log from user upload
              }
          };
          removeScript(() => {
              console.log("Script removed"); // Log from user upload
          });
      };
    }, []);
    */

    // Logic to handle payment callback from URL parameters, executed on component render.
    // This matches the structure from the user-provided original "OLD" code.
    // Note: Running this logic on every render can have side effects if not carefully managed.
    // The original relied on localStorage to prevent reprocessing.
    // A useEffect with proper dependencies is usually preferred for such side effects.
    // const search = new URLSearchParams(props.location?.search); // Comment from user upload (for class components)
    if (invoiceParams.has("ssl_invoice_number")) {
        const sslResult = invoiceParams.get("ssl_result");
        const confirmationNumber = invoiceParams.get("ssl_txn_id");
        // Logic from user upload for preventing reprocessing using localStorage:
        if (localStorage.getItem("confirmationNumber", "") !== confirmationNumber) {
            localStorage.setItem("confirmationNumber", confirmationNumber); // Store the new confirmation number
            setLoading(true); // Set loading true here, as processing starts

            if (sslResult === "0") { // String '0' for success
                console.log("payment was successfully processed!"); // Log from user upload
                const invoiceList = JSON.parse("[" + invoiceParams.get("ssl_invoice_number") + "]").map(String);
                const paymentAmountValue = parseFloat(invoiceParams.get("ssl_amount"));
                const accountNumberFromParam = invoiceParams.get("ssl_description");

                httpRequest.payInvoices(accountNumberFromParam, invoiceList, paymentAmountValue, confirmationNumber)
                    .then((response) => {
                        console.log(response); // Log API response
                    })
                    .catch((error) => {
                        setAlertMsg("Transaction was failed: " + error); // Error message from user upload
                        setOpenSnack(true);
                    })
                    .finally(() => {
                        navigate(`/invoices`, { replace: true }); // Navigate after processing
                        setLoading(false);
                    });
            } else {
                // Payment failed or was cancelled at the gateway.
                const resultMessage = invoiceParams.get("ssl_result_message") || "";
                setAlertMsg("Transaction was cancelled: " + resultMessage);
                setOpenSnack(true);
                navigate(`/invoices`, { replace: true });
                setLoading(false);
            }
        } else {
            // This confirmationNumber was already processed according to localStorage.
            // To avoid an infinite navigation loop if params are still in URL,
            // ensure navigation happens, or params are cleared.
            // This console.log might run on many renders if not careful.
            // console.log(`Confirmation number ${confirmationNumber} was already processed (from localStorage).`);
            // Consider navigating here as well if the goal is to clear params and prevent re-execution.
            // if (window.location.search.includes("ssl_invoice_number")) {
            //     navigate(`/invoices`, { replace: true });
            // }
        }
    }


    // Updates state for selected invoices. Passed to InvoicesListDatagrid.
    // Wrapped in useCallback to stabilize its reference for child component optimization.
    const setSelectedInvoicesFunc = useCallback((ivList, amount) => {
        let temp = {
            invoiceList: ivList,
            paymentAmount: parseFloat(amount) || 0,
        };
        setSelectedInvoices(temp);
    }, []); // setSelectedInvoices (state setter) has a stable reference.

    // Updates state for total outstanding invoices. Passed to InvoicesListDatagrid.
    // Original name in user upload: `setTotalInvoices`. Renamed to `setTotalInvoicesFunc` for clarity.
    // Wrapped in useCallback for stability.
    const setTotalInvoicesFunc = useCallback((ivList, amount) => {
        let temp = {
            invoiceList: ivList,
            paymentAmount: parseFloat(amount) || 0,
        };
        setTotalOutstanding(temp);
        if (showPaymentPart) { // Conditional DOM update from user upload
            const totalBalanceEl = document.getElementById("totalbalance");
            if (totalBalanceEl) {
                totalBalanceEl.innerHTML = `Total outstanding balance: ${amount}`;
            }
        }
    }, [showPaymentPart]); // Dependency: showPaymentPart.

    // Prepares payment details and opens the confirmation dialog.
    // Wrapped in useCallback for stability. Parameter name 'stripeInvoice' is from user upload.
    // Defined before checkoutSelected and checkoutTotal as they depend on it.
    const processPayment = useCallback((stripeInvoice) => {
       stripeInvoice.paymentAmount = Math.round(parseFloat(stripeInvoice.paymentAmount) * 100) / 100;
       const msg = `
        Your total to process is $ ${stripeInvoice.paymentAmount.toFixed(2)}.
        Invoice(s) selected - ${stripeInvoice.invoiceList.join(', ')}
        Click OK to proceed to checkout.
        `;
        setOpenCustomDialog(true);
        setCustomDialogMsg(msg);
        setCustomDialogTitle("Payment"); // Dialog title from user upload
    }, []); // Relies only on state setters, stable.

    // Initiates checkout for selected invoices.
    // Wrapped in useCallback for stability.
    const checkoutSelected = useCallback((event) => {
        console.log("Checking out"); // Log from user upload
        if (selectedInvoices.paymentAmount === 0) {
            setOpenSnack(true);
            setAlertMsg("Please select at least one invoice to pay.");
            return;
        }
        if(event) event.preventDefault();
        setPaymentData({
            paymentAmount: selectedInvoices.paymentAmount,
            invoiceList: selectedInvoices.invoiceList,
        });
        processPayment({ // Call the memoized processPayment
           paymentAmount: selectedInvoices.paymentAmount,
           invoiceList: selectedInvoices.invoiceList,
        });
    }, [selectedInvoices, processPayment]); // processPayment is a dependency.

    // Initiates checkout for total outstanding amount.
    // Wrapped in useCallback for stability.
    const checkoutTotal = useCallback((event) => {
        console.log("Checking out all"); // Log from user upload
        if(event) event.preventDefault();
        if (totalOutstanding.paymentAmount <= 0 && totalOutstanding.invoiceList.length === 0) {
            setOpenSnack(true);
            setAlertMsg("No outstanding balance to pay.");
            return;
        }
        setPaymentData({
            paymentAmount: totalOutstanding.paymentAmount,
            invoiceList: totalOutstanding.invoiceList,
        });
        processPayment({ // Call the memoized processPayment
            paymentAmount: totalOutstanding.paymentAmount,
            invoiceList: totalOutstanding.invoiceList,
         });
    }, [totalOutstanding, processPayment]); // processPayment is a dependency.


    // Submits the payment after user confirms in the dialog.
    // Passed as `dialogAction` to CustomDialog. Wrapped in useCallback.
    // Original name in user upload: `submitPayment`. Renamed to `submitPaymentConfirmed` for clarity.
    const submitPaymentConfirmed = useCallback(() => {
        setOpenCustomDialog(false);
        setLoading(true);
        let paymentAmountValue = paymentData.paymentAmount;
        let invoiceListValue = paymentData.invoiceList;
        paymentAmountValue = Math.round(paymentAmountValue * 100) / 100;

        if (!account) {
            setAlertMsg("Account information is not available.");
            setOpenSnack(true);
            setLoading(false);
            return;
        }

        httpRequest.getTransactionToken(account, paymentAmountValue, invoiceListValue.join(','))
            .then(function (response) {
                console.log("response returned!"); // Log from user upload
                console.log(response.data); // Log from user upload
                if (response.status !== 200 || !response.data || !response.data.token) {
                    setOpenSnack(true);
                    setAlertMsg("Please try again!"); // Message from user upload
                    setLoading(false);
                } else {
                    const data = response.data;
                    console.log(data); // Log from user upload
                    // PRODUCTION_NOTE: The ConvergePay URL should be environment-configurable.
                    window.location.href = "https://api.demo.convergepay.com/hosted-payments?ssl_txn_auth_token=" + data.token;
                    // window.open(...) // This was commented out in user upload
                    // window.location.reload(); // This was commented out in user upload
                }
            })
           .catch(function (error) {
                console.error("Error:", error); // Log from user upload
                setOpenSnack(true);
                setAlertMsg("Transaction was failed: " + (error.response?.data?.message || error.message)); // Improved error message
                setLoading(false);
            });
    }, [paymentData, account]); // Dependencies: paymentData and account.

    return (
      <Container maxWidth="lg" >
        {showPaymentPart && (
          <div style={{position: "relative",height: 90, backgroundColor: "white",}} >
            <Card
              style={{
                width: "fit-content",
                minWidth: 400,
                margin: "auto",
                marginTop: 10,
                paddingBottom: 10,
              }}
            >
              <CardContent>
                {/* Typography for total balance, from user upload (commented section) */}
                {/* <Typography variant='heading1' id='totalbalance'>Total outstanding balance: {(this.state.totalOutstanding?.paymentAmount)?.toFixed(2)} &emsp; </Typography> */}
                <Typography variant="h6" id="totalbalance"> {/* Using h6 for better semantics */}
                  Total outstanding balance: {totalOutstanding.paymentAmount ? parseFloat(totalOutstanding.paymentAmount).toFixed(2) : '0.00'} &emsp;
                </Typography>
                <Button size="small" variant="contained" color="primary"
                  startIcon={
                    <PaymentIcon
                      style={{
                        verticalAlign: "middle",
                        transform: "scale(1.5)",
                        color: palette.greys.white, // Assuming palette.greys.white is correctly defined
                      }}
                    />
                  }
                  disableRipple
                  onClick={checkoutTotal}
                  style={{ marginRight: "10px", marginLeft: "5px", float: "right" }} // Matched original string "10" to "10px"
                  disabled={!totalOutstanding.paymentAmount || totalOutstanding.paymentAmount <= 0}
                >
                  Pay Total
                </Button>
              </CardContent>
            </Card>
            <Button size="small"  variant="contained"  color="primary"
              startIcon={
                <PaymentIcon
                  style={{
                    verticalAlign: "middle",
                    transform: "scale(1.5)",
                    color: palette.greys.white,
                  }}
                />
              }
              disableRipple
              onClick={checkoutSelected}
              style={{ position: "absolute", right: 5, top: 30 }}
              disabled={!selectedInvoices.paymentAmount || selectedInvoices.paymentAmount <= 0}
            >
              Pay Selected
            </Button>
          </div>
        )}
        {/* Backdrop and InvoiceDialog component, commented out in user upload */}
        {/* <Backdrop style={{color: '#fff', zIndex:9}} open={openDialog}> {/* Using openDialog state from user upload */}
        {/* <InvoiceDialog
                        paymentAmount={this.state.stripeInvoice?.paymentAmount} // Adapting to functional component state would be needed
                        invoiceList={this.state.stripeInvoice?.invoiceList}
                        onClose={() => setOpenDialog(false)} // Use state setter
                        dialogAction={this.createStripePayment} // this.createStripePayment is not defined in this file
                    />
                </Backdrop> */}
        <Backdrop style={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}> {/* Ensure zIndex is appropriate */}
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* InvoiceList and InvoiceDatagrid components, commented out in user upload */}
        {/* <InvoiceList account={account} selectedInvoices={selectedInvoices} totalOutstanding={totalOutstanding}/>    */}
        {/* <div style={{ height: 1200, width: "100%" }}> */}
          {/* <InvoiceDatagrid
            account={account}
            selectedInvoices={selectedInvoices}
            totalOutstanding={totalOutstanding}
            setSelectedInvoices={setSelectedInvoicesFunc}
            setTotalInvoices={setTotalInvoicesFunc} // Use renamed function
          /> */}
        {/* </div> */}

        <InvoicesListDatagrid
            account={account}
            setSelectedInvoices={setSelectedInvoicesFunc}
            setTotalInvoices={setTotalInvoicesFunc} // Pass renamed and memoized function; original was `setTotalInvoices`
        />

        <CustomDialog
            open={openCustomDialog}
            onClose={() => { setOpenCustomDialog(false); }}
            dialogTitle={customDialogTitle}
            dialogMessage={customDialogMsg}
            dialogAction={submitPaymentConfirmed} // Use the correctly named and memoized function
        />

        <Snackbar
          open={openSnack}
          autoHideDuration={6000} // Increased duration from 1800
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => {setOpenSnack(false);}}
        >
          <Alert
            onClose={() => {setOpenSnack(false);}}
            severity={alertMsg.toLowerCase().includes("failed") || alertMsg.toLowerCase().includes("cancelled") || alertMsg.toLowerCase().includes("error") ? "error" : "info"}
            sx={{ width: "100%" }}
          >
            {alertMsg}
          </Alert>
        </Snackbar>

        {/* Footer conditional rendering, as in user upload */}
        {(props.isEmbedded === null || props.isEmbedded !== "yes") && (
            <footer> <Copyright /> </footer>
        )}
      </Container>
    );
}